
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/angazma",
      function () {
        return require("private-next-pages/angazma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/angazma"])
      });
    }
  